import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogResourcesData {
  description: any;
}

@Component({
  selector: 'my-portal-dialog-about',
  templateUrl: './dialog-about.component.html',
  styleUrls: ['./dialog-about.component.scss']
})
export class DialogAboutComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogAboutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogResourcesData) { }

  ngOnInit(): void {
  }

}
